import {Component, OnInit} from '@angular/core';
import {DataService, OrientDBCollectionView} from '@cosbeni/database';
import {ActivePromotionConfig} from '../config/active-promotion.config';

/**
 * 買取屋 顧客管理 (旧 kaitoriya.app /admin `cj-admin-customer` の移植)。
 *
 * OrientDB クラス `AP_Customer` を OrientDBCollectionView で一覧・追加・編集・削除する。
 * 保存は CollectionView 経由 (`saveChanges()` / `cancelChanges()`) で SQL は使わない。
 * サーバサイドフィルタ・ページングは kobeac 系と同じ流儀。
 */
@Component({
    standalone: false,
    selector: 'app-kaitoriya-customer',
    templateUrl: 'customer-management.component.html',
})
export class KaitoriyaCustomerManagementComponent implements OnInit {
    customers: OrientDBCollectionView;
    readonly = true;

    constructor(private dataService: DataService) {
        // OrientDBCollectionView(dataService, database, sql, className, filter, skip, pageSize, ...)
        this.customers = new OrientDBCollectionView(this.dataService, ActivePromotionConfig.DATABASE,
            'SELECT FROM AP_Customer', 'AP_Customer', '', 0, 100, true, true, false);
        this.customers.url = ActivePromotionConfig.SERVER_URL;
        this.customers.tokenName = ActivePromotionConfig.DATABASE + '_token';
    }

    ngOnInit(): void {
        this.customers.filterOnServer = true;
    }
}
